import React from 'react';
import PropTypes from 'prop-types';
import players from './players';

const getActivePlayer = (playerType, url) => (
  players.find((Player) => Player.typeName === playerType)
  || players.find((Player) => Player.canPlay(url))
);

const VideoPlayer = ({ url, playerType, opts }) => {
  const Player = getActivePlayer(playerType, url);

  return (
    <Player
      url={url}
      opts={opts}
    />
  );
};

VideoPlayer.defaultProps = {
  playerType: null,
};

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  opts: PropTypes.instanceOf(Object).isRequired,
  playerType: PropTypes.string,
};

export default VideoPlayer;
/* eslint "no-debugger": "off" */
